import { render, staticRenderFns } from "./AdditionalBankInformation.vue?vue&type=template&id=69d89119"
import script from "./AdditionalBankInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalBankInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports